import { render } from "./SFMInstalls.vue?vue&type=template&id=6059953c"
import script from "./SFMInstalls.vue?vue&type=script&lang=js"
export * from "./SFMInstalls.vue?vue&type=script&lang=js"

import exportComponent from "/home/desarollo2/Documents/GitHub/dicora-customers-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__